import { type ErrorMessage } from '@ctn/axios-util';
import { type AxiosError } from 'axios';

import { type ProcessedData } from '@/interfaces/model/fetch.interface';

export const processError = <T>(axiosResponse: AxiosError<T | ErrorMessage>): ProcessedData<T> => {
	const {status, response } = axiosResponse;
	const data = response?.data;
	const errorMessage = (data as ErrorMessage)?.message ?? axiosResponse.message;

	return { code: Number(status), data: data as T, error: errorMessage };
};
